import ShippingOrderPage from './ShippingOrderPage'


export default ShippingOrderPage